import API from "@/api/index"
import util from "@/mixins/util";
class updateOrder { // 배송지 수정
    getCreateClassConstants() {
        let CreateClassConstants = {
            ApiDataDefine: {
            },
        }
        return CreateClassConstants
    }

    makeParams(params) {
        let resultParams = this.getCreateClassConstants().ApiDataDefine;
        resultParams = Object.assign({}, resultParams, params);
        return resultParams;
    }

    getResultData(res, resultData) {
        if(res.hasOwnProperty('Info')) {
            resultData.resultData = res.Info;
            resultData.type = res.Info.status
        }
        return resultData
    }

    getApiMethod() {
        return API.$order.updateOrder
    }
}

class setExpress {
    getCreateClassConstants() {
        let CreateClassConstants = {
            ApiDataDefine: {
            },
        }
        return CreateClassConstants
    }
    makeParams(params) {
        let resultParams = this.getCreateClassConstants().ApiDataDefine;
        resultParams = Object.assign({}, resultParams, params);
        return resultParams;
    }

    getResultData(res, resultData) {
        if(res.hasOwnProperty('Info')) {
            resultData.resultData = res.Info;
            resultData.type = res.Info.status
        }
        return resultData
    }

    getApiMethod() {
        return API.$order.updateExpress
    }

}

class OrderClass {
    User = null;
    UserKey = 'mb_no';

    constructor(OrderUser) {
        let User = OrderUser || null,
            UserKey = OrderUser[this.getOrderClassConstants().UserKey] || null

        this.User = User;
        this.UserKey = UserKey;
    }
    getOrderClassConstants() {
        let OrderClassConstants = {
            ResultData: {key: null, type: -1, resultData: {}},
            UserKey: 'mb_no',
            OrderKey: 'o_idx',
            OrderCardKey: 'c_idx',
        }
        return OrderClassConstants;
    }
    _getOrderType(type) {
        let writeClass = null;
        if(type === 'updateOrder') {
            writeClass = new updateOrder()
        }else if(type ==='setExpress'){ // 추가
            writeClass = new setExpress()
        }else if(type ===''){ // 추가

        }
        return writeClass
    }

    _checkAbleWriteUser() {
        if(util.isEmpty(this.User)) {
            return false;
        }
        return true;
    }

    _getOrderKey(params) {
        let orderKey = this.getOrderClassConstants().orderKey;
        if(params.hasOwnProperty(orderKey)) {
            return params[orderKey]
        }
        return null;
    }

    getOrderBeforeData(orderData){ // 배송전 데이터
        let resultData = {};
        resultData = this._getOrderBasicData(orderData, resultData);
        resultData = this._getOrderBasicImageData(orderData, resultData);
        resultData = this._getOrderShippingInfoData(orderData,resultData);
        resultData = this._getOrderDepositData(orderData,resultData);
        resultData = this._getOrderStatusData(orderData,resultData)
        return resultData;
    }
    getOrderCompleteData(orderData){ // 결제완료 데이터
        let resultData = {};
        resultData = this._getOrderBasicData(orderData, resultData);
        resultData = this._getOrderBasicImageData(orderData, resultData);
        resultData = this._getOrderShippingInfoData(orderData,resultData);
        resultData = this._getOrderingCancelData(orderData, resultData);
        resultData = this._getOrderDepositData(orderData,resultData);
        resultData = this._getOrderPayData(orderData, resultData);
        resultData = this._getOrderStatusData(orderData,resultData)
        return resultData;
    }
    getOrderPreparingData(orderData){ // 배송준비중 데이터
        let resultData = {};
        resultData = this._getOrderBasicData(orderData, resultData);
        resultData = this._getOrderBasicImageData(orderData, resultData);
        resultData = this._getOrderShippingInfoData(orderData,resultData);
        resultData = this._getOrderingCancelData(orderData, resultData);
        resultData=this._getOrderDepositData(orderData,resultData);
        resultData = this._getOrderPayData(orderData, resultData);
        resultData=this._getOrderStatusData(orderData,resultData)
        return resultData;
    }
    getOrderCancelData(orderData){ //취소관리 데이터
        let resultData = {};
        resultData = this._getOrderBasicData(orderData, resultData);
        resultData = this._getOrderBasicImageData(orderData, resultData);
        resultData = this._getOrderingCancelData(orderData, resultData);
        resultData = this._getOrderDepositData(orderData, resultData);
        resultData = this._getOrderPayData(orderData, resultData);
        resultData = this._getOrderShippingInfoData(orderData,resultData);

        resultData = this._getOrderCancelImageData(orderData,resultData); // 취소 이미지
        return resultData;
    }

    getOrderExchangeData(orderData){ //교환관리 데이터
        let resultData = {};
        resultData = this._getOrderBasicData(orderData, resultData);
        resultData = this._getOrderBasicImageData(orderData, resultData);
        resultData = this._getOrderExchangeData(orderData, resultData);
        resultData = this._getOrderDepositData(orderData, resultData);
        resultData = this._getOrderPayData(orderData, resultData);
        resultData = this._getOrderShippingInfoData(orderData,resultData);

        resultData = this._getOrderTradeImageData(orderData,resultData); // 교환 이미지
        return resultData;
    }

    getOrderRefundData(orderData){ //환불관리 데이터
        let resultData = {};
        resultData = this._getOrderBasicData(orderData, resultData);
        resultData = this._getOrderBasicImageData(orderData, resultData);
        resultData = this._getOrderRefundData(orderData, resultData);
        resultData = this._getOrderRefundDepositData(orderData, resultData); // 입금정보
        resultData = this._getOrderPayData(orderData, resultData);
        resultData = this._getOrderShippingInfoData(orderData,resultData);
        resultData = this._getOrderRefundInfoData(orderData,resultData); // 추가 매핑

        resultData = this._getOrderRefundImageData(orderData,resultData); // 환불 이미지
        return resultData;
    }

    getOrderInfoData(orderData) {
        let resultData = {};
        resultData = this._getOrderBasicData(orderData, resultData);
        resultData = this._getOrderInformationAllPriceData(orderData, resultData);
        return resultData;
    }

    _getOrderBasicData(orderData, resultData){
        resultData.orderKey = orderData.c_idx;
        resultData.orderDate = orderData.order_date;//주문일
        resultData.orderNumber = orderData.o_id;//주문번호
        resultData.orderItemCode = orderData.c_id;//주문번호
        resultData.orderIdx = orderData.o_idx;
        if(orderData.hasOwnProperty('orderInfo') && orderData.orderInfo.length > 0) {
            resultData.orderPeopleId = orderData.orderInfo[0].mb_id;//주문자 아이디
            resultData.orderNickname = orderData.orderInfo[0].mb_nick;//주문자 닉네임
            resultData.orderName = orderData.orderInfo[0].mb_name;//주문자명
            resultData.orderHp = orderData.orderInfo[0].mb_hp;//주문자핸드폰
        }else {
            resultData.orderPeopleId = orderData.mb_id;//주문자 아이디
            resultData.orderNickname = orderData.mb_nick;//주문자 닉네임
            resultData.orderName = orderData.mb_name;//주문자명
            resultData.orderHp = orderData.mb_hp;//주문자핸드폰
        }

        resultData.itemName = orderData.i_name;//상품명
        resultData.itemOption = orderData.io_title;//옵션
        resultData.detailMemo = orderData.o_memo;//메모

        if(orderData.hasOwnProperty('orderInfo') && orderData.orderInfo.hasOwnProperty('mb_id')){
            resultData.orderHp = orderData.orderInfo[0].mb_hp
            resultData.orderNickname = orderData.orderInfo[0].mb_nick
            resultData.orderPeopleId = orderData.mb_id;//주문자 아이디
        }
        resultData.memberNo = orderData.mb_no
        resultData.itemNo = orderData.i_idx

        return resultData;
    }

    _getOrderRefundInfoData(orderData, resultData){
        if(orderData.hasOwnProperty('orderInfo')){
            resultData.orderNickname = orderData.orderInfo[0].mb_nick
            resultData.orderPeopleId = orderData.orderInfo[0].mb_id
            resultData.orderHp = orderData.orderInfo[0].mb_hp
        }
        return resultData;
    }
    _getOrderBasicImageData(orderData, resultData) {
        resultData.itemFiles = [];
        if(!util.isEmpty(orderData.itemFiles)) {
            resultData.itemFiles = orderData.itemFiles.filter(file => file.a_idx != null);
        }
        return resultData;
    }
    _getOrderRefundImageData(orderData, resultData) { //환불 이미지
        resultData.refundImageFiles = [];
        if(orderData.hasOwnProperty('itemRefundImages')){
            let arr = orderData.itemRefundImages;
            util.Array.each(arr, (file, index, key) => {
                if(!util.isEmpty(file.a_idx)){
                    resultData.refundImageFiles.push(file);
                }
            })
        }
        return resultData;
    }
    _getOrderTradeImageData(orderData, resultData) { //교환 이미지
        resultData.tradeImageFiles = [];
        if(orderData.hasOwnProperty('itemTradeImages')){
            let arr = orderData.itemTradeImages;
            util.Array.each(arr, (file, index, key) => {
                if(!util.isEmpty(file.a_idx)){
                    resultData.tradeImageFiles.push(file);
                }
            })
        }
        return resultData;
    }
    _getOrderCancelImageData(orderData, resultData) { //취소이미지
        resultData.cancelImageFiles = [];
        if(orderData.hasOwnProperty('itemCancelImages')){
            let arr = orderData.itemCancelImages;
            util.Array.each(arr, (file, index, key) => {
                if(!util.isEmpty(file.a_idx)){
                    resultData.cancelImageFiles.push(file);
                }
            })
        }
        return resultData;
    }


    _getOrderStatusData(orderData, resultData){
        resultData.orderStatus = orderData.c_status;//상태
        return resultData;

    }

    //환불정보
    _getOrderRefundData(orderData, resultData){
        resultData.orderStatus = orderData.o_status;//상태
        resultData.requestDate = orderData.created_at;//환불요청일
        resultData.refundReason = orderData.or_content;//환불사유
        resultData.acceptDate = orderData.or_accept_at;//환불승인일
        resultData.denyDate = orderData.or_deny_at;//환불거절일
        resultData.adminReason = orderData.or_reason;//환불승인추가안내/거절사유
        resultData.doneDate = orderData.or_done_at;//환불완료일
        resultData.orderMember = orderData.order_member //주문자
        resultData.refundMember = orderData.refund_member //환불요청자
        return resultData;
    }
    // // 환불시 사용자 첨부 이미지
    //     _getOrderRefundImgData(orderData, resultData){
    //         resultData.refundImageFiles =[]
    //     if(orderData.hasOwnProperty('itemImages')){
    //         let arr = orderData.itemImages;
    //         util.Array.each(arr, (file, index, key) => {
    //             if(!util.isEmpty(file.a_idx)){
    //                 resultData.refundImageFiles.push(file);
    //             }
    //         })
    //     }
    //     return resultData;
    // }
    //교환정보
    _getOrderExchangeData(orderData, resultData){
        resultData.orderStatus = orderData.o_status;//상태
        resultData.requestDate = orderData.created_at;//교환요청일
        resultData.exchangeReason = orderData.ot_content;//교환사유
        resultData.acceptDate = orderData.ot_accept_at;//교환승인일
        resultData.denyDate = orderData.ot_deny_at;//교환거절일
        resultData.adminReason = orderData.ot_reason;//교환승인추가안내/거절사유
        resultData.doneDate = orderData.ot_done_at;//교환완료일
        resultData.orderMember = orderData.order_member
        resultData.tradeMember = orderData.trade_member
        return resultData;
    }
    //취소정보
    _getOrderingCancelData(orderData, resultData){
        resultData.orderStatus = orderData.c_status;//상태
        if(!util.isEmpty(orderData.cancelInfo)) {
            let data = orderData.cancelInfo[0]
            resultData.requestDate = data.order_cancel_date;//취소요청일
            resultData.cancelReason = data.cc_content;//취소사유
            resultData.cancelRejectDate = data.cc_reject_at;//취소완료/거절일
            resultData.adminReason = data.cc_comment;//취소승인추가안내/거절사유
            resultData.cancelStatus = data.cc_status;
            resultData.isCancelData = true;
            // resultData.orderMember = orderData.order_member
            // resultData.cancelMember = orderData.cancellator
        }
        return resultData;
    }

    //입금정보
    _getOrderDepositData(orderData, resultData){
        // resultData.depositName = orderData.pb_deposit_name;//입금자
        resultData.bankName = orderData.b_name;//입금은행
        resultData.price = orderData.c_price;//입금액
        return resultData;
    }
    // 환불정보 입금정보
    _getOrderRefundDepositData(orderData, resultData){
        if(!util.isEmpty(orderData.bankInfo)){
            if(!util.isEmpty(orderData.bankInfo[0].pb_deposit_name)){
                resultData.depositName = orderData.bankInfo[0].pb_deposit_name;//입금자
            }
            if(!util.isEmpty(orderData.bankInfo[0].b_name)){
                resultData.bankName = orderData.bankInfo[0].b_name;//입금자
            }
        }
        return resultData;
    }

    //결제정보
    _getOrderPayData(orderData, resultData){
        resultData.receiptDate = orderData.o_receipt_time;//결제일
        resultData.payRoute = orderData.o_payment;//결제수단
        resultData.price = orderData.c_price;//결제금액
        return resultData;
    }

    _getOrderShippingInfoData(orderData, resultData){ // 배송정보
        resultData.recieverName = orderData.oa_name;// 수령인 이름
        resultData.recieverPhone = orderData.oa_hp;// 수령인 전화번호
        resultData.zipCode = orderData.oa_zip; // 배송지 우편번호
        resultData.address = orderData.oa_addr1 // 주소
        resultData.addressDetail = orderData.oa_addr2 // 상세주소
        resultData.shippingRequest = orderData.od_name // 배송 요청사항
        resultData.shippingMemo = orderData.oa_memo // 배송메세지
        if(!util.isEmpty(orderData.addressInfo)){
            let data = orderData.addressInfo[0]
            resultData.invoiceNumber = data.ce_invoice // 송장번호
            resultData.deliveryCompany = data.ed_idx // 택배사
            resultData.invoiceDate = data.ce_invoice_time // 배송일
            resultData.shippingNumber = data.ce_uuid // 배송번호
            resultData.shippingDoneDate = data.ce_invoice_end_time // 배송완료일
        }
        return resultData
    }

    _getOrderInformationAllPriceData(orderData, resultData) {
        resultData.orderAllPrice = orderData.o_price;
        resultData.orderCartPrice = orderData.c_price;
        resultData.orderSendPrice = orderData.o_send_price;
        return resultData;
    }

    runWrite(type, data) {
        let writeClass = this._getOrderType(type);
        let resultData = this.getOrderClassConstants().ResultData
        return new Promise(async resolve => {
            // if(!this._checkAbleWriteUser()) {
            //     resolve(resultData)
            //     return false;
            // } // 필요시 주석 풀고 진행
            if (writeClass == null) {
                resolve(resultData)
                return false;
            }
            let params = writeClass.makeParams(data)
            //  let itemKey = this._getItemKey(params) // 추후 필요시 주석 풀고 진행
            let func = writeClass.getApiMethod()
            func(params).then(res => res.Data.Result).then( res => {
                let resData = writeClass.getResultData(res, resultData);
                resolve(resData)
            })
        })
    }

}

class OtherStatusOrderClass {
    User = null;
    UserKey = 'mb_no';

    constructor(OrderUser) {
        let User = OrderUser || null,
            UserKey = OrderUser[this.getOrderClassConstants().UserKey] || null

        this.User = User;
        this.UserKey = UserKey;
    }
    getOrderClassConstants() {
        let OrderClassConstants = {
            ResultData: {key: null, type: -1, resultData: {}},
            UserKey: 'mb_no',
            OrderKey: 'o_idx',
            OrderCardKey: 'c_idx',
        }
        return OrderClassConstants;
    }
    getOrderOtherStatusBasicData(orderData, resultData){
        resultData.orderKey = orderData.c_idx;
        resultData.orderDate = orderData.order_created_at;//주문일
        resultData.orderNumber = orderData.o_id;//주문번호
        resultData.orderItemCode = orderData.c_id;//주문번호
        resultData.orderIdx = orderData.o_idx;

        resultData.orderPeopleId = orderData.mb_id;//주문자 아이디
        resultData.orderNickname = orderData.mb_nick;//주문자 닉네임
        resultData.orderName = orderData.mb_name;//주문자명
        resultData.orderHp = orderData.mb_hp;//주문자핸드폰

        resultData.itemName = orderData.i_name;//상품명
        resultData.itemOption = orderData.co_name;//옵션
        resultData.detailMemo = orderData.o_memo;//메모

        if(orderData.hasOwnProperty('orderInfo') && orderData.orderInfo.hasOwnProperty('mb_id')){
            resultData.orderHp = orderData.orderInfo[0].mb_hp
            resultData.orderNickname = orderData.orderInfo[0].mb_nick
            resultData.orderPeopleId = orderData.mb_id;//주문자 아이디
        }
        resultData.memberNo = orderData.mb_no
        resultData.itemNo = orderData.i_idx

        return resultData;
    }
    getOrderBasicImageData(orderData, resultData) {
        resultData.itemFiles = [];
        if(!util.isEmpty(orderData.itemFiles)) {
            resultData.itemFiles = orderData.itemFiles.filter(file => file.a_idx != null);
        }
        return resultData;
    }

    getOrderShippingInfoData(orderData, resultData){ // 배송정보
        resultData.recieverName = orderData.oa_name;// 수령인 이름
        resultData.recieverPhone = orderData.oa_hp ?? '';// 수령인 전화번호
        resultData.zipCode = orderData.oa_zip ?? ''; // 배송지 우편번호
        resultData.address = orderData.oa_addr1 ?? ''; // 주소
        resultData.addressDetail = orderData.oa_addr2 ?? ''; // 상세주소
        resultData.shippingRequest = orderData.od_name ?? ''; // 배송 요청사항
        resultData.shippingMemo = orderData.oa_memo ?? ''; // 배송메세지

        resultData.invoiceNumber = orderData.ce_invoice // 송장번호
        resultData.deliveryCompany = orderData.ed_idx // 택배사
        resultData.invoiceDate = orderData.ce_invoice_time // 배송일
        resultData.shippingNumber = orderData.ce_uuid // 배송번호
        resultData.shippingDoneDate = orderData.ce_invoice_end_time // 배송완료일
        return resultData
    }


    //결제정보
    getOrderPayData(orderData, resultData){
        resultData.receiptDate = orderData.order_created_at;//결제일
        resultData.payRoute = orderData.o_payment;//결제수단
        resultData.price = orderData.c_price;//결제금액
        return resultData;
    }

    _getOrderType(type) {
        let writeClass = null;
        if(type === 'updateOrder') {
            writeClass = new updateOrder()
        }else if(type ==='setExpress'){ // 추가
            writeClass = new setExpress()
        }else if(type ===''){ // 추가

        }
        return writeClass
    }

    runWrite(type, data) {
        let writeClass = this._getOrderType(type);
        let resultData = this.getOrderClassConstants().ResultData
        return new Promise(async resolve => {
            // if(!this._checkAbleWriteUser()) {
            //     resolve(resultData)
            //     return false;
            // } // 필요시 주석 풀고 진행
            if (writeClass == null) {
                resolve(resultData)
                return false;
            }
            let params = writeClass.makeParams(data)
            //  let itemKey = this._getItemKey(params) // 추후 필요시 주석 풀고 진행
            let func = writeClass.getApiMethod()
            func(params).then(res => res.Data.Result).then( res => {
                let resData = writeClass.getResultData(res, resultData);
                resolve(resData)
            })
        })
    }
}

class CancelClass {
    User = null;
    UserKey = 'mb_no';

    OrderClass = null;

    constructor(OrderUser) {
        let User = OrderUser || null,
            UserKey = OrderUser[this.getOrderClassConstants().UserKey] || null

        this.User = User;
        this.UserKey = UserKey;
        this.OrderClass = new OtherStatusOrderClass(OrderUser);
    }
    getOrderClassConstants() {
        let OrderClassConstants = {
            ResultData: {key: null, type: -1, resultData: {}},
            UserKey: 'mb_no',
            OrderKey: 'o_idx',
            OrderCardKey: 'c_idx',
            OrderCancelKey: 'cc_idx',
        }
        return OrderClassConstants;
    }

    _getCancelData(orderData, resultData) {
        resultData.cancelKey = orderData.cc_idx;
        resultData.cancelStatus = orderData.cc_status;
        resultData.requestDate = orderData.status_created_at; //요청일
        resultData.cancelReason = orderData.cc_content;
        resultData.cancelCompleteDate = orderData.cc_canceled_at;//취소완료일
        resultData.cancelRejectDate = orderData.cc_reject_at;//취소거절일
        resultData.adminReason = orderData.cc_comment;//취소승인추가안내/거절사유
        return resultData;
    }

    _getCancelImage(orderData, resultData) {
        resultData.cancelImageFiles = [];
        if(orderData.hasOwnProperty('statusFiles')){
            let arr = orderData.statusFiles;
            util.Array.each(arr, (file, index, key) => {
                if(!util.isEmpty(file.a_idx)){
                    resultData.cancelImageFiles.push(file);
                }
            })
        }
        return resultData;
    }

    getOrderCancelData(orderData) {
        let resultData = {};
        resultData = this.OrderClass.getOrderOtherStatusBasicData(orderData, resultData);
        resultData = this.OrderClass.getOrderBasicImageData(orderData, resultData);
        resultData = this.OrderClass.getOrderShippingInfoData(orderData, resultData);
        resultData = this.OrderClass.getOrderPayData(orderData, resultData);
        resultData = this._getCancelData(orderData, resultData);
        resultData = this._getCancelImage(orderData, resultData);
        return resultData;
    }

    getCreateClassConstants() {
        let CreateClassConstants = {
            ApiDataDefine: {
                type: 'cancel',
            },
        }
        return CreateClassConstants
    }

    _makeParams(params) {
        let resultParams = this.getCreateClassConstants().ApiDataDefine;
        resultParams = Object.assign({}, resultParams, params);
        return resultParams;
    }

    _getResultData(res, resultData) {
        if(res.hasOwnProperty('Info')) {
            resultData.resultData = res.Info;
            resultData.type = res.Info.status
        }
        return resultData
    }

    _getApiMethod() {
        return API.$order.updateOrderCart
    }

    runWrite(data) {
        let resultData = this.getOrderClassConstants().ResultData
        let params = this._makeParams(data)
        let func = this._getApiMethod();
        return new Promise(async resolve => {
            func(params).then(res => res.Data.Result).then( res => {
                let resData = this._getResultData(res, resultData);
                resolve(resData)
            })
        });
    }
}
class ExchangeClass {
    User = null;
    UserKey = 'mb_no';

    OrderClass = null;

    constructor(OrderUser) {
        let User = OrderUser || null,
            UserKey = OrderUser[this.getOrderClassConstants().UserKey] || null

        this.User = User;
        this.UserKey = UserKey;
        this.OrderClass = new OtherStatusOrderClass(OrderUser);
    }
    getOrderClassConstants() {
        let OrderClassConstants = {
            ResultData: {key: null, type: -1, resultData: {}},
            UserKey: 'mb_no',
            OrderKey: 'o_idx',
            OrderCardKey: 'c_idx',
            OrderCancelKey: 'ct_idx',
        }
        return OrderClassConstants;
    }
    _getExchangeReasonTypeName(type) {
        switch (type) {
            case 1:
                return '사이즈 교환';
            case 2:
                return '품질의 문제';
            case 3:
                return '기타';
            default:
                return '-'
        }
    }
    _getExchangeData(orderData, resultData) {
        resultData.exchangeKey = orderData.ct_idx;
        resultData.exchangeStatus = orderData.ct_status;
        resultData.requestDate = orderData.status_created_at; //요청일
        resultData.reasonType = this._getExchangeReasonTypeName(orderData.ct_type); //1:사이즈 교환,2:품질의 문제,3:기타
        resultData.reason = orderData.ct_reason ?? '';
        resultData.tradeName = orderData.ct_trade_name ?? ''; // 반품 수령인명
        resultData.tradeHp = orderData.ct_trade_hp ?? ''; //반품 수령인 전화번호
        resultData.tradeZipcode = orderData.ct_trade_zipcode ?? ''; //반품 수령인 주소 (우편번호)
        resultData.tradeAddress = orderData.ct_trade_addr1 ?? ''; //반품 수령인 주소 (주소1)
        resultData.tradeAddressDetail = orderData.ct_trade_addr2 ?? ''; //반품 수령인 주소 (주소2)
        resultData.tradeDelivery = orderData.ct_trade_delivery ?? ''; //반품 수령인 배송요청사항
        resultData.tradeDeliveryMemo = orderData.ct_trade_memo ?? ''; //반품 수령인 배송요청사항 메모
        resultData.receiverName = orderData.ct_receive_name ?? ''; //교환 수령인명
        resultData.receiverHp = orderData.ct_receive_hp ?? ''; //교환 수령인 전화번호
        resultData.receiverZipcode = orderData.ct_receive_zipcode ?? ''; //교환 수령인 주소 (우편번호)
        resultData.receiverAddress = orderData.ct_receive_addr1 ?? ''; //교환 수령인 주소 (주소1)
        resultData.receiverAddressDetail = orderData.ct_receive_addr2 ?? ''; //교환 수령인 주소 (주소2)
        resultData.receiverDelivery = orderData.ct_receive_delivery ?? ''; //교환 수령인 배송요청사항
        resultData.receiverDeliveryMemo = orderData.ct_receive_memo ?? ''; //교환 수령인 배송요청사항 메모
        resultData.exchangeAcceptDate = orderData.ct_accept_at ?? '';//승인일
        resultData.exchangeCompleteDate = orderData.ct_done_at ?? '';//완료일
        resultData.exchangeRejectDate = orderData.ct_deny_at ?? '';//취소거절일
        resultData.adminReason = orderData.ct_comment ?? '';//취소승인추가안내/거절사유
        return resultData;
    }

    _getExchangeImage(orderData, resultData) {
        resultData.exchangeImageFiles = [];
        if(orderData.hasOwnProperty('statusFiles')){
            let arr = orderData.statusFiles;
            util.Array.each(arr, (file, index, key) => {
                if(!util.isEmpty(file.a_idx)){
                    resultData.exchangeImageFiles.push(file);
                }
            })
        }
        return resultData;
    }
    getOrderExchangeData(orderData) {
        let resultData = {};
        resultData = this.OrderClass.getOrderOtherStatusBasicData(orderData, resultData);
        resultData = this.OrderClass.getOrderBasicImageData(orderData, resultData);
        resultData = this.OrderClass.getOrderShippingInfoData(orderData, resultData);
        resultData = this.OrderClass.getOrderPayData(orderData, resultData);
        resultData = this._getExchangeData(orderData, resultData);
        resultData = this._getExchangeImage(orderData, resultData);
        return resultData;
    }

    getCreateClassConstants() {
        let CreateClassConstants = {
            ApiDataDefine: {
                type: 'trade',
            },
        }
        return CreateClassConstants
    }

    _makeParams(params) {
        let resultParams = this.getCreateClassConstants().ApiDataDefine;
        resultParams = Object.assign({}, resultParams, params);
        return resultParams;
    }

    _getResultData(res, resultData) {
        if(res.hasOwnProperty('Info')) {
            resultData.resultData = res.Info;
            resultData.type = res.Info.status
        }
        return resultData
    }

    _getApiMethod() {
        return API.$order.updateOrderCart
    }

    runWrite(data) {
        let resultData = this.getOrderClassConstants().ResultData
        let params = this._makeParams(data)
        let func = this._getApiMethod();
        return new Promise(async resolve => {
            func(params).then(res => res.Data.Result).then( res => {
                let resData = this._getResultData(res, resultData);
                resolve(resData)
            })
        });
    }
}

class RefundClass {
    User = null;
    UserKey = 'mb_no';

    OrderClass = null;

    constructor(OrderUser) {
        let User = OrderUser || null,
            UserKey = OrderUser[this.getOrderClassConstants().UserKey] || null

        this.User = User;
        this.UserKey = UserKey;
        this.OrderClass = new OtherStatusOrderClass(OrderUser);
    }
    getOrderClassConstants() {
        let OrderClassConstants = {
            ResultData: {key: null, type: -1, resultData: {}},
            UserKey: 'mb_no',
            OrderKey: 'o_idx',
            OrderCardKey: 'c_idx',
            OrderCancelKey: 'cr_idx',
        }
        return OrderClassConstants;
    }
    _getRefundReasonTypeName(type) {
        //1:주문실수,2:서비스 불만족,3:배송 지연,4:단순 변심,5:품질의 문제,6:기타
        switch (type) {
            case 1:
                return '주문실수';
            case 2:
                return '서비스 불만족';
            case 3:
                return '배송 지연';
            case 4:
                return '단순 변심';
            case 5:
                return '품질의 문제';
            case 6:
                return '기타';
            default:
                return '-'
        }
    }
    _getRefundData(orderData, resultData) {
        resultData.refundKey = orderData.cr_idx;
        resultData.refundStatus = orderData.cr_status;
        resultData.requestDate = orderData.status_created_at; //요청일
        resultData.reasonTypeKey = orderData.cr_type; //1:주문실수,2:서비스 불만족,3:배송 지연,4:단순 변심,5:품질의 문제,6:기타
        resultData.reasonType = this._getRefundReasonTypeName(orderData.cr_type); //1:주문실수,2:서비스 불만족,3:배송 지연,4:단순 변심,5:품질의 문제,6:기타
        resultData.reason = orderData.cr_reason ?? '';
        resultData.serviceReason = orderData.cr_complain ?? ''; //서비스 불만족 사유
        resultData.tradeName = orderData.cr_name ?? ''; // 반품 수령인명
        resultData.tradeHp = orderData.cr_hp ?? ''; //반품 수령인 전화번호
        resultData.tradeZipcode = orderData.cr_zipcode ?? ''; //반품 수령인 주소 (우편번호)
        resultData.tradeAddress = orderData.cr_addr1 ?? ''; //반품 수령인 주소 (주소1)
        resultData.tradeAddressDetail = orderData.cr_addr2 ?? ''; //반품 수령인 주소 (주소2)
        resultData.tradeDelivery = orderData.cr_delivery ?? ''; //반품 수령인 배송요청사항
        resultData.tradeDeliveryMemo = orderData.cr_memo ?? ''; //반품 수령인 배송요청사항 메모
        resultData.refundAcceptDate = orderData.cr_accept_at ?? '';//승인일
        resultData.refundCompleteDate = orderData.cr_done_at ?? '';//완료일
        resultData.refundRejectDate = orderData.cr_deny_at ?? '';//취소거절일
        resultData.adminReason = orderData.cr_comment ?? '';//취소승인추가안내/거절사유
        return resultData;
    }

    _getRefundImage(orderData, resultData) {
        resultData.refundImageFiles = [];
        if(orderData.hasOwnProperty('statusFiles')){
            let arr = orderData.statusFiles;
            util.Array.each(arr, (file, index, key) => {
                if(!util.isEmpty(file.a_idx)){
                    resultData.refundImageFiles.push(file);
                }
            })
        }
        return resultData;
    }
    getOrderRefundData(orderData) {
        let resultData = {};
        resultData = this.OrderClass.getOrderOtherStatusBasicData(orderData, resultData);
        resultData = this.OrderClass.getOrderBasicImageData(orderData, resultData);
        resultData = this.OrderClass.getOrderShippingInfoData(orderData, resultData);
        resultData = this.OrderClass.getOrderPayData(orderData, resultData);
        resultData = this._getRefundData(orderData, resultData);
        resultData = this._getRefundImage(orderData, resultData);
        return resultData;
    }

    getCreateClassConstants() {
        let CreateClassConstants = {
            ApiDataDefine: {
                type: 'refund',
            },
        }
        return CreateClassConstants
    }

    _makeParams(params) {
        let resultParams = this.getCreateClassConstants().ApiDataDefine;
        resultParams = Object.assign({}, resultParams, params);
        return resultParams;
    }

    _getResultData(res, resultData) {
        if(res.hasOwnProperty('Info')) {
            resultData.resultData = res.Info;
            resultData.type = res.Info.status
        }
        return resultData
    }

    _getApiMethod() {
        return API.$order.updateOrderCart
    }

    runWrite(data) {
        let resultData = this.getOrderClassConstants().ResultData
        let params = this._makeParams(data)
        let func = this._getApiMethod();
        return new Promise(async resolve => {
            func(params).then(res => res.Data.Result).then( res => {
                let resData = this._getResultData(res, resultData);
                resolve(resData)
            })
        });
    }
}
export default {
    OrderClass: OrderClass,
    CancelClass: CancelClass,
    ExchangeClass: ExchangeClass,
    RefundClass: RefundClass,
}
